<template>
  <div>
    <v-dialog v-model="printDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="success"
          dark
        >
          <div class="text--lighten-1 text-body-2 mb-4">
            <v-icon class="mr-5">mdi-printer-check</v-icon>
            {{ $t('Imprimindo') }}
          </div>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{ $t('Tem certeza de que deseja excluir este checklist?') }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="error"
            text
            @click="confirmDeleteChecklist(selectedChecklist)"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <div class="d-flex justify-end mb-2">
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="selected && selected.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            depressed
            class="mb-2 mr-2 primary-button"
            dark
            @click="getZip"
          >
            {{ $t('Baixar certificados') }}
          </v-btn>
        </template>
        <span>{{ $t('Máximo de 25 arquivos por vez') }}</span>
      </v-tooltip>
      <v-btn
        class="hidden-sm-and-down primary-button"
        dark
        depressed
        @click="visible = !visible"
      >
        Filtros
      </v-btn>
      <v-btn
        class="hidden-md-and-up"
        small
        color="#BBCF20"
        depressed
        @click="visible = !visible"
      >
        <v-icon color="#fff"> mdi-filter </v-icon>
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-show="visible">
        <v-row class="ma-0" dense>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Instituição') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="institution.name"
              outlined
              class="primary-input"
              disabled
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Unidade') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="unidadeId"
              :items="unidades"
              item-value="id"
              item-text="name"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4">
            <label class="label">{{ $t('Setor') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.departmentIds"
              :items="departments"
              multiple
              item-value="id"
              item-text="name"
              :loading="departmentLoading"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
              :search-input.sync="departmentSearch"
              @blur="departmentSearch = ''"
              clearable
              chips
              deletable-chips
              small-chips
              ><template
                v-slot:selection="{ attrs, index, item, select, selected }"
              >
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="#BBCF20"
                  text-color="#fff"
                  small
                  @click="select"
                  @click:close="removeSetor(index)"
                >
                  {{ item.name }}
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ item.name }}
                </span>
              </template></v-autocomplete
            >
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Equipamento padrão') }}</label>
            <v-autocomplete
              hide-details="auto"
              v-model="filter.standardEquipmentIds"
              :items="standardEquipments"
              multiple
              item-value="id"
              item-text="name"
              :loading="standardEquipmentLoading"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
              clearable
              chips
              deletable-chips
              small-chips
              :search-input.sync="equipamentSearch"
              @blur="equipamentSearch = ''"
              ><template
                v-slot:selection="{ attrs, index, item, select, selected }"
              >
                <v-chip
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  color="#BBCF20"
                  text-color="#fff"
                  small
                  @click="select"
                  @click:close="removeStandardEquipment(index)"
                >
                  {{ item.name }}
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                <span class="text-caption">
                  {{ item.name }}
                </span>
              </template></v-autocomplete
            >
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Identificação') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="equipmentIdentification"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Código patrimônio') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="propertyCode"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Número de Série') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="serialNumber"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Equipamento') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="equipment"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Fabricante') }}</label>

            <v-autocomplete
              hide-details="auto"
              v-model="manufacturer"
              :items="manufacturers"
              item-text="name"
              item-value="name"
              outlined
              append-icon="mdi-chevron-down"
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Modelo') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="model"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Nº O.S.') }}</label>
            <v-text-field
              hide-details="auto"
              v-model="serviceOrderNumber"
              outlined
              class="primary-input"
              @keyup.enter="filterTable"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-row class="ma-0" no-gutters>
              <v-col cols="12" class="text-center">
                <label class="label">{{ $t('Data Checklist') }}</label>
              </v-col>
              <v-col>
                <v-menu
                  ref="menuStartDate"
                  v-model="menuStartDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      placeholder="Inicial"
                      v-model="startDate"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="checklistStartDate = parseDate(startDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input mr-1"
                      @keyup.enter="filterTable"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="checklistStartDate"
                    min="1900-01-01"
                    @change="save"
                    locale="pt"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col class="ma-0 py-0" cols="10" sm="5" md="5" lg="5">
                <v-menu
                  ref="menuEndDate"
                  v-model="menuEndDate"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      hide-details="auto"
                      placeholder="Final"
                      :disabled="!startDate"
                      v-model="endDate"
                      v-mask="['##/##/####']"
                      prepend-inner-icon="mdi-calendar"
                      @blur="checklistEndDate = parseDate(endDate)"
                      v-bind="attrs"
                      v-on="on"
                      autocomplete="off"
                      outlined
                      class="primary-input"
                      @keyup.enter="filterTable"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="checklistEndDate"
                    @change="save"
                    locale="pt"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Checklist Validado') }}</label>
            <v-autocomplete
              single-line
              :items="[
                { text: 'Sim', value: true },
                { text: 'Não', value: false },
              ]"
              item-text="text"
              item-value="value"
              clearable
              hide-details="auto"
              v-model="filter.validated"
              outlined
              class="primary-input"
              append-icon="mdi-chevron-down"
              @keyup.enter="filterTable"
            >
              <template #message="{ message }">
                {{ $t(message) }}
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <label class="label">{{ $t('Aprovação') }} </label>
            <v-autocomplete
              single-line
              :items="[
                { text: 'Sim', value: true },
                { text: 'Não', value: false },
              ]"
              item-text="text"
              item-value="value"
              clearable
              hide-details="auto"
              v-model="filter.approved"
              outlined
              class="primary-input"
              append-icon="mdi-chevron-down"
              @keyup.enter="filterTable"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" class="d-flex align-center justify-end">
            <v-btn
              class="mx-2 secondary-button"
              color="#BBCF20"
              depressed
              @click="filterTable"
            >
              <span>{{ $t('Filtrar') }}</span>
              <v-icon class="pl-2">mdi-magnify</v-icon>
            </v-btn>

            <v-btn
              depressed
              color="#20202066"
              class="clear-button mr-0"
              @click="reset"
            >
              <span>{{ $t('Limpar') }}</span>
              <v-icon class="pl-2">mdi-cached</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <div class="wrapper mobile">
      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum checklist encontrado')"
        :headers="headersMobile"
        :items="checklists"
        show-select
        v-model="selected"
        class="main-table"
        hide-default-footer
        show-expand
        :items-per-page="pageSize"
        :header-props="headerProps"
        :mobile-breakpoint="330"
        :single-expand="false"
        :expanded.sync="expanded"
        :item-class="isInactive"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      >
        <template #[`item.identification`]="{ item }">
          {{ item.equipment.identification }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="userType < 4 || userType >= 7"
                class="ma-1"
                color="#0F3565"
                dark
                @click="editChecklist(item)"
                v-bind="attrs"
                v-on="on"
                x-small
                depressed
              >
                <v-icon small> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Editar') }}</span>
          </v-tooltip>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Equipamento') }}:</strong>
                {{ item.equipment.name }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Código Patrimônio') }}:</strong>
                {{
                  item.equipment.propertyCode != null
                    ? item.equipment.propertyCode
                    : $t('Sem registro')
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Nº O.S.') }}:</strong>
                {{ item.serviceOrder.number }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Data') }}</strong>
                {{
                  item.checklistDate != null
                    ? formatDateTime(item.checklistDate)
                    : formatDateTime(item.createAt)
                }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Ações') }}: </strong>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="ma-1"
                      dark
                      @click="generatePDF(item)"
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      depressed
                      :color="item.approved ? `#BBCF20` : `error`"
                    >
                      <v-icon small color="#F5F5F5"> mdi-printer </v-icon>
                    </v-btn>
                  </template>
                  <span>Imprimir</span>
                </v-tooltip>
              </p>
            </v-col>
          </td>
        </template>
      </v-data-table>
      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span>
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>

    <div class="wrapper desktop">
      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum checklist encontrado')"
        :headers="headers"
        :items="checklists"
        show-select
        v-model="selected"
        class="main-table"
        hide-default-footer
        hide-default-header
        :header-props="headerProps"
        :items-per-page="pageSize"
        :item-class="isInactive"
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'data-table-select' &&
                          header.value != 'actions'
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.identification`]="{ item }">
          {{ item.equipment.identification }}
        </template>
        <template #[`item.equipmentName`]="{ item }">
          {{ item.equipment.name }}
        </template>

        <template #[`item.propertyCode`]="{ item }">
          {{
            item.equipment.propertyCode != ''
              ? item.equipment.propertyCode
              : $t('Sem registro')
          }}
        </template>
        <template #[`item.serviceOrderNumber`]="{ item }">
          {{ item.serviceOrder.number }}
        </template>

        <template #[`item.date`]="{ item }">
          {{
            item.checklistDate != null
              ? formatDateTime(item.checklistDate)
              : formatDateTime(item.createAt)
          }}
        </template>

        <template #[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="
                  item.serviceOrder.closeServiceOrderDateTime
                    ? '#B9CE1E'
                    : '#F5F5F5'
                "
                dark
                @click.stop="callServiceOrder(item)"
                v-bind="attrs"
                v-on="on"
                small
                depressed
              >
                <v-icon color="#2A8EA4" small> mdi-view-module </v-icon>
              </v-btn>
            </template>
            <span>Ordem de Serviço</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-show="userType < 4 || userType >= 7"
                class="ma-1"
                color="#0F3565"
                dark
                @click="editChecklist(item)"
                v-bind="attrs"
                v-on="on"
                small
                depressed
              >
                <v-icon small> mdi-pencil-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Editar') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="userType >= 0 && userType <= 2"
                class="ma-1"
                small
                color="#A42A2AD9"
                style="font-weight: bold"
                dark
                v-bind="attrs"
                @click="openDeleteDialog(item)"
                v-on="on"
                depressed
              >
                <v-icon small color="white"> mdi-trash-can-outline </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Excluir') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-1"
                dark
                @click.stop="generatePDF(item)"
                v-bind="attrs"
                v-on="on"
                small
                depressed
                :color="item.approved ? `#BBCF20` : `error`"
              >
                <v-icon small color="#F5F5F5"> mdi-printer </v-icon>
              </v-btn>
            </template>
            <span>Imprimir</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <div class="pagination">
        <div class="item-pagination block-one">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="pageSize = size"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <div class="registros" v-if="totalItensOnPage">
            <span> 1 - {{ totalItensOnPage }} de {{ totalItems }} </span>
          </div>
        </div>

        <div class="item-pagination block-two">
          <v-pagination
            class="pagination-item"
            v-model="page"
            :length="totalPages"
            :total-visible="3"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/sass/variables.scss';
.mobile {
  display: none;
  @media (max-width: $tablet-1) {
    display: block;
  }
}
.desktop {
  @media (max-width: $tablet-1) {
    display: none;
  }
}
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}

.v-picker.v-card
  >>> .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(
    .v-btn--outlined
  ) {
  background-color: #ffffff;
}

.v-picker.v-card >>> .v-btn > .v-btn__content .v-icon {
  color: #000000;
}
</style>

<script>
import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  components: {},

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.userType = JSON.parse(localStorage.getItem('institution')).userType

    if (this.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    await Promise.all([
      this.getStandardEquipments(),
      this.getDepartments(),
      this.getManufacturers(),
    ])

    if (this.unidades.length == 1) {
      this.unidadeId = this.unidades[0].id
    }

    this.updateTable()
  },

  data: () => ({
    equipamentSearch: '',
    departmentSearch: '',
    errorMessage: '',
    expanded: [],
    visible: false,
    dialog: false,
    editDialog: false,
    printDialog: false,
    dialogKey: false,
    loading: false,
    departmentLoading: false,
    standardEquipmentLoading: false,
    error: false,
    menuStartDate: false,
    menuEndDate: false,
    userType: null,
    institution: {},
    unidadeId: null,
    unidades: [],
    departmentId: null,
    departments: [],
    standardEquipmentId: null,
    standardEquipments: [],
    checklists: [],
    currentChecklist: {},
    equipmentIdentification: null,
    serviceOrderNumber: null,
    equipment: null,
    model: null,
    manufacturer: null,
    serialNumber: null,
    propertyCode: null,
    serviceOrderNumber: null,
    checklistStartDate: null,
    startDate: null,
    checklistEndDate: null,
    endDate: null,
    minDate: null,
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 25, 50, 100],
    totalItems: 0,
    totalItensOnPage: 0,
    filter: {
      validated: null,
      page: 1,
      pageSize: 10,
      equipmentIdentification: null,
      equipment: null,
      model: null,
      manufacturer: null,
      serialNumber: null,
      propertyCode: null,
      serviceOrderNumber: null,
      standardEquipmentIds: null,
      departmentIds: null,
      institutionId: null,
      unidadeId: null,
      checklistStartDate: null,
      checklistEndDate: null,
    },
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
      },
      {
        text: 'Nº Identificação',
        align: 'center',

        value: 'identification',
      },
      {
        text: 'Equipamento',
        align: 'center',

        value: 'equipmentName',
      },
      {
        text: 'Cód. Patrimônio',
        align: 'center',

        value: 'propertyCode',
        sortable: false,
      },
      {
        text: 'Nº O.S.',

        align: 'center',
        value: 'serviceOrderNumber',
      },
      {
        text: 'Data',

        align: 'center',
        value: 'date',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 200,
      },
    ],
    headersMobile: [
      {
        text: 'Nº Identificação',
        align: 'center',

        value: 'identification',
      },
      {
        text: 'Ações',
        align: 'center',
        sortable: false,
        value: 'actions',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    generalService: new GeneralService(),
    selected: [],
    manufacturers: [],
    deleteDialog: false,
    selectedChecklist: null,
  }),

  methods: {
    removeSetor(item) {
      this.filter.departmentIds.splice(item, 1)
      this.filter.departmentIds = [...this.filter.departmentIds]
    },
    removeStandardEquipment(item) {
      this.filter.standardEquipmentIds.splice(item, 1)
      this.filter.standardEquipmentIds = [...this.filter.standardEquipmentIds]
    },
    getManufacturers() {
      this.manufacturerLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institution.id}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufacturerLoading = false
        })
        .catch(() => {
          this.manufacturerLoading = false
        })
    },

    async getZip() {
      this.$toast(
        `${this.$t('Imprimindo registros')}: ${this.selected.length} ${this.$t(
          'selecionados'
        )}`
      )
      const ids = this.selected.map((x) => x.id)
      await this.apiService
        .post(`checklistServiceOrder/getZipChecklist`, { ids })
        .then((response) => {
          var pedfResult = 'data:application/zip;base64,' + response.content
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute('download', `Checklists`)
          document.body.appendChild(link)
          link.click()
          this.selected = []
        })
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    openDeleteDialog(checklist) {
      this.selectedChecklist = checklist
      this.deleteDialog = true
    },

    async confirmDeleteChecklist(checklist) {
      try {
        this.loading = true
        await this.apiService.delete(
          `ChecklistServiceOrder/delete/${checklist.id}`
        )
        this.$toast.success(this.$t('Checklist excluido com sucesso'))
        this.updateTable()
      } catch (error) {
        this.$toast.error(this.$t('Erro ao excluir o checklist.'))
      } finally {
        this.loading = false
        this.deleteDialog = false
      }
    },

    editChecklist(checklist) {
      const checklistServiceOrder = {
        ServiceOrderId: checklist.serviceOrderId,
        ChecklistId: checklist.id,
        isValidatorSigned: checklist.isValidatorSigned,
        EquipmentId: checklist.equipmentId,
        ChecklistDate: checklist.checklistDate,
      }
      sessionStorage.setItem(
        'serviceOrder',
        JSON.stringify(checklist.serviceOrder)
      )

      sessionStorage.setItem('checklist', JSON.stringify(checklistServiceOrder))
      this.$router.push('/formChecklist')
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.equipmentIdentification = this.equipmentIdentification
      this.filter.equipment = this.equipment
      this.filter.model = this.model
      this.filter.manufacturer = this.manufacturer
      this.filter.serialNumber = this.serialNumber
      this.filter.propertyCode = this.propertyCode
      this.filter.serviceOrderNumber = this.serviceOrderNumber
      this.filter.unidadeId = this.unidadeId
      this.filter.checklistStartDate = this.checklistStartDate
      this.filter.checklistEndDate = this.checklistEndDate

      this.updateTable()
    },

    isInactive(value) {
      return value.equipment.department.status == 1 ? 'departmentInactive' : ''
    },

    async updateTable() {
      this.loading = true
      this.filter.institutionId = this.institution.id

      await this.apiService
        .post('checklistServiceOrder/checklists', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.checklists = response.content.checklists
          this.totalItems = response.content.pager.totalItems
          this.totalItensOnPage = response.content.checklists.length
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },

    async getUnidades() {
      await this.apiService
        .get(`unidade/list/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
        })
    },

    async getStandardEquipments() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institution.id
        )

      this.standardEquipmentLoading = false
    },

    async getDepartments() {
      this.departmentLoading = true

      await this.apiService
        .get(`department/listActive/${this.institution.id}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
    },

    async generatePDF(checklist) {
      const route = this.$router.resolve({
        path: `/printChecklist/${checklist.id}`,
      })
      window.open(route.href, '_blank')
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    formatDateTime(date) {
      return Utils.dateTime(date)
    },

    reset() {
      this.equipmentIdentification = null
      this.serviceOrderNumber = null
      this.standardEquipmentId = null
      this.unidadeId = null
      this.equipment = null
      this.model = null
      this.manufacturer = null
      this.serialNumber = null
      this.propertyCode = null
      this.startDate = null
      this.endDate = null
      this.checklistStartDate = null
      this.checklistEndDate = null
      this.filter = {
        validated: null,
        page: 1,
        pageSize: 10,
        equipmentIdentification: null,
        equipment: null,
        model: null,
        manufacturer: null,
        serialNumber: null,
        propertyCode: null,
        serviceOrderNumber: null,
        standardEquipmentId: null,
        departmentIds: null,
        institutionId: null,
        unidadeId: null,
        checklistStartDate: null,
        checklistEndDate: null,
      }
      this.updateTable()
    },

    callServiceOrder(checklist) {
      if (this.userType == 5) return
      this.$router.push(`/editServiceOrder/${checklist.serviceOrderId}`)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.checklistStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.checklistStartDate)
        .toISOString()
        .substr(0, 10)
      this.endDate = this.formatInputDate(this.checklistEndDate)
      this.$refs.menuEndDate.save(date)
    },
  },

  watch: {
    selected(val) {
      if (val.length > 25) {
        this.$nextTick(() => {
          this.selected = val.slice(0, 25)
        })
      }
    },
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },
  },
}
</script>
